import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-assign-chart-failed',
  templateUrl: './assign-chart-failed.component.html',
  styleUrls: ['./assign-chart-failed.component.scss']
})
export class AssignChartFailedComponent implements OnInit {
  message: string;

  constructor(
    public dialogRef: MatDialogRef<AssignChartFailedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.translateService.get('WEBSITE_MESSAGES').subscribe(res => {
      const errorMessage = res.find(x => x.ERROR_CODE === this.data.errorCode);
      this.message = errorMessage ?
        errorMessage.MESSAGE : this.data.message ? this.data.message : res.find(x => x.ERROR_CODE === '0').MESSAGE;
    });
  }

  ok() {
    this.dialogRef.close();
  }
}
